// store/modules/subscriptionModule.js
import axios from "@/axios.js";
import { db } from "@/firebase";
import { doc, onSnapshot } from "firebase/firestore";

export default {
    namespaced: true,

    state: () => ({
        subscription: null,
        unsubscribe: null,
        // ✅ ใหม่ — สถานะการโหลด แยก "กำลังโหลด" ออกจาก "โหลดแล้วแต่ไม่มีแพ็กเกจ/โหลดไม่สำเร็จ"
        // เดิมหน้าบ้านดูแค่ subscription?.name → ร้านที่ไม่มีเอกสาร subscription (API ตอบ 404) เห็น
        // skeleton ค้างตลอดไป (Tabnav.vue) · "idle" | "loading" | "ready" | "none" | "error"
        status: "idle",
        pageId: null,
    }),

    getters: {
        getSubscription: (state) => state.subscription,
        getSubscriptionStatus: (state) => state.status,
    },

    mutations: {
        SET_SUB(state, payload) {
            state.subscription = payload;
        },
        SET_UNSUB(state, fn) {
            state.unsubscribe = fn;
        },
        SET_STATUS(state, { status, pageId }) {
            state.status = status;
            if (pageId !== undefined) state.pageId = pageId;
        },
    },

    actions: {
        // โหลดข้อมูล subscription จาก API
        // (backend สร้างแพ็กเกจทดลองใช้ให้อัตโนมัติถ้าร้านยังไม่มี — ดู backend utils/trialSubscription.js)
        async loadSubscription({ commit, state }, pageId) {
            // เปลี่ยนเพจ → ล้างของเพจเก่าก่อน กันโชว์แพ็กเกจของอีกเพจ
            if (state.pageId && state.pageId !== pageId) commit("SET_SUB", null);
            commit("SET_STATUS", { status: "loading", pageId });
            try {
                const res = await axios.get(
                    `${process.env.VUE_APP_BACKEND_URL}/api/subscription/${pageId}`
                );

                commit("SET_SUB", res.data.data);
                commit("SET_STATUS", { status: res.data.data ? "ready" : "none" });
            } catch (err) {
                console.error("Error loadSubscription:", err.response?.data || err);
                // realtime listener อาจได้ข้อมูลมาก่อนแล้ว — ไม่ทับสถานะ ready
                if (state.status !== "ready") {
                    commit("SET_STATUS", { status: err.response?.status === 404 ? "none" : "error" });
                }
            }
        },

        // ฟัง realtime เครดิตจาก Firestore
        async listenSubscriptionRealtime({ commit, state }, pageId) {
            if (state.unsubscribe) state.unsubscribe(); // ปิด listener เดิมก่อน

            const ref = doc(db, "subscription", pageId);

            const unsub = onSnapshot(ref, (snap) => {
                if (snap.exists()) {
                    commit("SET_SUB", snap.data());
                    commit("SET_STATUS", { status: "ready", pageId });
                }
            }, (err) => {
                console.error("Error listenSubscriptionRealtime:", err);
            });

            commit("SET_UNSUB", unsub);
        },
    }
};
